import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import {
  MyTimesheetPageTitle,
  MyTimesheetUserRequestsRequests,
} from "my-timesheet/components";
import {
  useMyTimesheetDashboardDate,
} from "my-timesheet/hooks";
import { OcPageTransition } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyTimesheetUserRequestsPageProps {
  role: string;
}

export const MyTimesheetUserRequestsPage: React.FC<MyTimesheetUserRequestsPageProps> = ({ role }) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();
  const isExaminer = role === "examiner";

  const {
    currentDate,
    period,
    handlePeriodChange,
    handleChangeCurrentDate,
    periodStart,
    periodEnd,
  } = useMyTimesheetDashboardDate(
    isExaminer ? "examinerUserRequests" : "viewerUserRequests",
  );

  return (
    <OcPageTransition>
      <Box padding={isMobile ? "0px" : "16px"}>
        <MyTimesheetPageTitle
          title={isExaminer ? t("OC_APPROVE_REQUESTS") : t("OC_REQUESTS_VIEW")}
          showDateRange={true}
          currentDate={currentDate}
          handleChangeCurrentDate={handleChangeCurrentDate}
          period={period === "week" || period === "month" ? period : "week"}
          handlePeriodChange={(period) =>
            handlePeriodChange(period as "week" | "month")
          }
          isMobile={isMobile}
        />
        <Box height="16px" />
        <MyTimesheetUserRequestsRequests
          periodStart={periodStart.toISOString()}
          periodEnd={periodEnd.toISOString()}
          role={role}
          isMobile={isMobile}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyTimesheetUserRequestsPage;
